import api from './api';

export const createOrder = async (orderData) => {
  try {
    const response = await api.post('/orders', orderData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getShippingQuote = async (payload) => {
  try {
    const response = await api.post('/orders/shipping/quote', payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getMyOrders = async () => {
  try {
    const response = await api.get('/orders/my');
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getOrder = async (id) => {
  try {
    const response = await api.get(`/orders/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getAllOrders = async () => {
  try {
    const response = await api.get('/orders');
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateOrderStatus = async (id, status) => {
  try {
    const response = await api.put(`/orders/${id}/status`, { status });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateOrderStage = async (id, stage, awbNumber = null, returnPickupAwb = null) => {
  try {
    const response = await api.put(`/orders/${id}/stage`, { stage, awbNumber, returnPickupAwb });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const trackOrder = async (id) => {
  try {
    const response = await api.get(`/orders/${id}/track`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const trackExchangeShipment = async (id) => {
  try {
    const response = await api.get(`/orders/${id}/track/exchange`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const addDelhiveryWaybill = async (id, waybill, orderId) => {
  try {
    const response = await api.put(`/orders/${id}/delhivery/waybill`, { waybill, orderId });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const addExchangeWaybill = async (id, waybill) => {
  try {
    const response = await api.put(`/orders/${id}/delhivery/exchange-waybill`, { waybill });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createDelhiveryShipment = async (id) => {
  try {
    const response = await api.post(`/orders/${id}/delhivery/shipment`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createExchangeShipment = async (id) => {
  try {
    const response = await api.post(`/orders/${id}/delhivery/exchange-shipment`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const cancelDelhiveryShipment = async (id) => {
  try {
    const response = await api.delete(`/orders/${id}/delhivery/cancel`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const cancelExchangeShipment = async (id) => {
  try {
    const response = await api.delete(`/orders/${id}/delhivery/exchange-shipment`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateOrderItemCustom = async (orderId, itemId, customSize) => {
  try {
    const response = await api.put(`/orders/${orderId}/items/${itemId}/custom`, { customSize });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getOrderById = async (id) => {
  try {
    const response = await api.get(`/orders/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const cancelOrder = async (orderId, reason, note) => {
  try {
    const response = await api.post(`/orders/${orderId}/cancel`, { reason, note });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const cancelOrderItem = async (orderId, itemId, reason, note) => {
  try {
    const response = await api.post(`/orders/${orderId}/items/${itemId}/cancel`, { reason, note });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const requestReturn = async (orderId, itemId, reason, quantity, bankDetails) => {
  try {
    const response = await api.post(`/orders/${orderId}/items/${itemId}/return`, {
      returnReason: reason,
      returnQuantity: quantity,
      bankDetails
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const requestExchange = async (orderId, itemId, reason, newSize) => {
  try {
    const response = await api.post(`/orders/${orderId}/items/${itemId}/exchange`, { 
      reason, 
      newSize 
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const testDelhivery = async () => {
  try {
    const response = await api.get('/orders/test-delhivery');
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const trackByWaybill = async (waybill) => {
  try {
    const response = await api.get(`/orders/track/waybill/${waybill}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createTestShipment = async (orderId) => {
  try {
    const response = await api.post(`/orders/${orderId}/delhivery/shipment/test`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const simulateDeliveryStatus = async (orderId, status) => {
  try {
    const response = await api.post(`/orders/${orderId}/simulate-status`, { status });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const approveReturn = async (orderId, itemId) => {
  try {
    const response = await api.put(`/orders/${orderId}/items/${itemId}/return/approve`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const approveExchange = async (orderId, itemId) => {
  try {
    const response = await api.put(`/orders/${orderId}/items/${itemId}/exchange/approve`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const rejectExchange = async (orderId, itemId) => {
  try {
    const response = await api.put(`/orders/${orderId}/items/${itemId}/exchange/reject`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createReturnPickup = async (orderId) => {
  try {
    const response = await api.post(`/orders/${orderId}/delhivery/return-pickup`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const cancelReturnPickup = async (orderId) => {
  try {
    const response = await api.delete(`/orders/${orderId}/delhivery/return-pickup`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const setExchangeReversePickupWaybill = async (orderId, waybill) => {
  try {
    const response = await api.put(`/orders/${orderId}/delhivery/exchange-reverse-pickup`, { waybill });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const syncAllShippedOrders = async () => {
  try {
    const response = await api.post('/orders/sync-tracking');
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
